var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuilding07(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.9987 7.33333H3.06536C2.692 7.33333 2.50531 7.33333 2.3627 7.406C2.23726 7.46991 2.13528 7.5719 2.07136 7.69734C1.9987 7.83995 1.9987 8.02663 1.9987 8.4V14M10.9987 7.33333H12.932C13.3054 7.33333 13.4921 7.33333 13.6347 7.406C13.7601 7.46991 13.8621 7.5719 13.926 7.69734C13.9987 7.83995 13.9987 8.02663 13.9987 8.4V14M10.9987 14V4.13333C10.9987 3.3866 10.9987 3.01323 10.8534 2.72801C10.7255 2.47713 10.5216 2.27316 10.2707 2.14532C9.98547 2 9.6121 2 8.86536 2H7.13203C6.38529 2 6.01193 2 5.72671 2.14532C5.47583 2.27316 5.27185 2.47713 5.14402 2.72801C4.9987 3.01323 4.9987 3.3866 4.9987 4.13333V14M14.6654 14H1.33203M7.33203 4.66667H8.66536M7.33203 7.33333H8.66536M7.33203 10H8.66536",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding07);
export default __webpack_public_path__ + "static/media/building-07.4c0072ad3e46b010b64239a50e921949.svg";
export { ForwardRef as ReactComponent };